<div class="content" #contentEl>
  <div class="layer-list-container">
    <app-radio-group
      class="radio-group"
      [scrollable]="true"
      [items]="layerItemList"
      [showIcon]="siiaMode"
      [(value)]="layerSelected"
      [valueExpr]="valueExpr"
      (onItemSelected)="onItemSelected()"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    ></app-radio-group>
  </div>

  <div class="actions-bottom">
    <div class="distance-slider-container">
      <div class="title" *ngIf="!!distanceLabel">
        {{ distanceLabel }}
      </div>

      <app-range-slider
        class="range-slider"
        [(value)]="distance"
        (onChanged)="onDistanceChanged($event)"
        [step]="1"
        [min]="0"
        [max]="50"
        [appBlockModalDrag]="!(isMobileModeObservable | async)"
      ></app-range-slider>
    </div>
  </div>
</div>

<app-loading-panel
  [visible]="loadingController.changes | async"
  [container]="contentEl"
></app-loading-panel>
